// Browser shims for the Node globals the wallet SDKs expect.
//
// vite-plugin-node-polyfills used to inject `Buffer`, `global` and `process` into every bundle
// (its `include` option only narrows the *module* polyfills — the globals default to all three).
// The plugin is unmaintained and its alias mapping breaks vite's rolldown resolver, so the
// globals are set here instead. `define: { global: 'globalThis' }` in vite.config.ts rewrites the
// bare `global` identifier at build time; the assignment below additionally covers code that
// reaches for it as a property (`globalThis.global`), which the define cannot rewrite.
//
// This module must be the first import of the entry file: the wallet SDKs read `Buffer` while
// their module bodies execute, so the assignment has to happen before they are evaluated.
import process from 'process';
import { Buffer } from 'buffer';

globalThis.Buffer ??= Buffer;
globalThis.process ??= process;
globalThis.global ??= globalThis;
